var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBathWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6B75028B-3908-4AEE-8D7F-02E1A33264F7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Summary-Cards",
    transform: "translate(-436.000000, -316.000000)",
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Property",
    transform: "translate(360.000000, 274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-bath",
    transform: "translate(74.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0042651,11 L15.9957349,11 C16.5503752,11 17,11.4437166 17,11.9998075 L19,12 L19,5.49607027 C19,4.66882964 18.329699,4 17.5,4 C16.673651,4 16,4.67436998 16,5.50461102 L16,5.76756439 C16.5978014,6.11337381 17,6.75971764 17,7.5 C17,8.6045695 13,8.6045695 13,7.5 C13,6.75971764 13.4021986,6.11337381 14,5.76756439 L14,5.50461102 C14,3.57027781 15.5686036,2 17.5,2 C19.4332859,2 21,3.56327513 21,5.49607027 L21,12 C21.552891,12 22,12.4438648 22,13 C22,13.5522847 21.5542301,14 21.0013542,14 L21,16 C21,18.2090154 19.2084848,19.9997997 17,20 L17,21.0009493 C17,21.5527098 16.5561352,22 16,22 C15.4477153,22 15,21.5566468 15,21.0009493 L15,20 L9,20 L9,21.0009493 C9,21.5527098 8.55613518,22 8,22 C7.44771525,22 7,21.5566468 7,21.0009493 L7,20 C4.79082664,19.9997992 3,18.2045206 3,16 L3,14 C2.44710896,14 2,13.5561352 2,13 C2,12.4477153 2.44576991,12 2.99864581,12 L11,12 C11,11.4476291 11.4509752,11 12.0042651,11 Z M5,14.0026245 L5,16 C5,17.1019327 5.89745391,18 7.00037063,18 L16.9996294,18 C18.1040474,18 19,17.104237 19,16 L19,14.0056152 L17,14.005188 L17,15.0001925 C17,15.5523709 16.5490248,16 15.9957349,16 L12.0042651,16 C11.4496248,16 11,15.5562834 11,15.0001925 L11,14.0039063 L5,14.0026245 Z M7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 Z M10,7.5 C9.17157288,7.5 8.5,6.82842712 8.5,6 C8.5,5.17157288 9.17157288,4.5 10,4.5 C10.8284271,4.5 11.5,5.17157288 11.5,6 C11.5,6.82842712 10.8284271,7.5 10,7.5 Z M6,5 C5.17157288,5 4.5,4.32842712 4.5,3.5 C4.5,2.67157288 5.17157288,2 6,2 C6.82842712,2 7.5,2.67157288 7.5,3.5 C7.5,4.32842712 6.82842712,5 6,5 Z",
    id: "path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathWhite);
export default __webpack_public_path__ + "static/media/bath-white.906418a7b30bad3019eff84934639ece.svg";
export { ForwardRef as ReactComponent };